var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: _vm.drawerWidth,
        maskClosable: false,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading
      },
      on: { close: _vm.handleCancel }
    },
    [
      _c(
        "div",
        {
          style: {
            width: "100%",
            border: "1px solid #e9e9e9",
            padding: "10px 16px",
            background: "#fff"
          }
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: { model: _vm.model, rules: _vm.validatorRules }
                },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["premission.menuType"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol
                      }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          on: { change: _vm.onChangeMenuType },
                          model: {
                            value: _vm.model.menuType,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "menuType", $$v)
                            },
                            expression: "model.menuType"
                          }
                        },
                        [
                          _c("a-radio", { attrs: { value: 0 } }, [
                            _vm._v(
                              _vm._s(_vm.language["premission.levelOneMenu"])
                            )
                          ]),
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v(_vm._s(_vm.language["premission.submenu"]))
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [
                            _vm._v(_vm._s(_vm.language["premission.BP"]))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.menuLabel,
                        prop: "name",
                        hasFeedback: ""
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["premission.mustPremission"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.name,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "name", $$v)
                          },
                          expression: "model.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.model.menuType == 0,
                          expression: "model.menuType==0"
                        }
                      ],
                      attrs: {
                        label: _vm.language["premission.menuCategory"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        "validate-status": _vm.validateStatus,
                        hasFeedback: true,
                        required: true
                      }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          on: { change: function($event) {} },
                          model: {
                            value: _vm.model.menuCategory,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "menuCategory", $$v)
                            },
                            expression: "model.menuCategory"
                          }
                        },
                        [
                          _c("a-radio", { attrs: { value: "web" } }, [
                            _vm._v("web")
                          ]),
                          _c("a-radio", { attrs: { value: "app" } }, [
                            _vm._v("app")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.model.menuType == 0,
                          expression: "model.menuType==0"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        "validate-status": _vm.applicationValidateStatus,
                        hasFeedback: true,
                        required: true,
                        label: _vm.language["premission.applicationName"]
                      }
                    },
                    [
                      _c("span", { attrs: { slot: "help" }, slot: "help" }, [
                        _vm._v(
                          _vm._s(
                            _vm.applicationValidateStatus == "error"
                              ? _vm.language["premission.mustApplication"]
                              : "  "
                          )
                        )
                      ]),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            allowClear: "",
                            disabled:
                              _vm.$store.getters.application.applicationType ==
                              "platform"
                                ? !!_vm.model.id
                                : true,
                            placeholder:
                              _vm.language["premission.mustApplication"]
                          },
                          model: {
                            value: _vm.model.applicationId,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "applicationId", $$v)
                            },
                            expression: "model.applicationId"
                          }
                        },
                        _vm._l(_vm.application, function(item, index) {
                          return _c(
                            "a-select-option",
                            {
                              key: index.toString(),
                              attrs: { value: item.id }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.applicationName) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "description",
                        label: _vm.language["premission.languageKey"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["premission.mustLanguageKey"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.description,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "description", $$v)
                          },
                          expression: "model.description"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.model.menuType != 0,
                          expression: "model.menuType!=0"
                        }
                      ],
                      attrs: {
                        label: _vm.language["premission.previousMenu"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        "validate-status": _vm.validateStatus,
                        hasFeedback: true,
                        required: true
                      }
                    },
                    [
                      _c("span", { attrs: { slot: "help" }, slot: "help" }, [
                        _vm._v(
                          _vm._s(
                            _vm.validateStatus == "error"
                              ? _vm.language["premission.mustPreviousMenu"]
                              : "  "
                          )
                        )
                      ]),
                      _c("a-tree-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          dropdownStyle: {
                            maxHeight: "200px",
                            overflow: "auto"
                          },
                          treeData: _vm.treeData,
                          placeholder:
                            _vm.language["premission.mustPreviousMenu"],
                          disabled: _vm.disableSubmit
                        },
                        on: { change: _vm.handleParentIdChange },
                        model: {
                          value: _vm.model.parentId,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "parentId", $$v)
                          },
                          expression: "model.parentId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "url",
                        label: _vm.language["premission.url"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: _vm.language["premission.mustURL"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.url,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "url", $$v)
                          },
                          expression: "model.url"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "component",
                        label: _vm.language["premission.component"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: _vm.language["premission.mustComponent"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.component,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "component", $$v)
                          },
                          expression: "model.component"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.model.menuType == 0,
                          expression: "model.menuType==0"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.redirectAddress"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder:
                            _vm.language["premission.mustRedirectAddress"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.redirect,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "redirect", $$v)
                          },
                          expression: "model.redirect"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.show,
                          expression: "!show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "perms",
                        label: _vm.language["premission.perms"]
                      }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: _vm.language["premission.mustPerms"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.perms,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "perms", $$v)
                          },
                          expression: "model.perms"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.show,
                          expression: "!show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.permsType"]
                      }
                    },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: _vm.language["premission.mustPermsType"],
                          type: "radio",
                          dictCode: "global_perms_type"
                        },
                        model: {
                          value: _vm.model.permsType,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "permsType", $$v)
                          },
                          expression: "model.permsType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.show,
                          expression: "!show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.status"]
                      }
                    },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: _vm.language["premission.musetStatus"],
                          type: "radio",
                          dictCode: "valid_status"
                        },
                        model: {
                          value: _vm.model.status,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "status", $$v)
                          },
                          expression: "model.status"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.icon"]
                      }
                    },
                    [
                      _c(
                        "a-input",
                        {
                          attrs: {
                            placeholder: _vm.language["premission.mustIcon"],
                            readOnly: _vm.disableSubmit
                          },
                          model: {
                            value: _vm.model.icon,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "icon", $$v)
                            },
                            expression: "model.icon"
                          }
                        },
                        [
                          _c("a-icon", {
                            attrs: { slot: "addonAfter", type: "setting" },
                            on: { click: _vm.selectIcons },
                            slot: "addonAfter"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "sortNo",
                        label: _vm.language["common.sort"]
                      }
                    },
                    [
                      _c("a-input-number", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          placeholder: _vm.language["common.mustSort"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.sortNo,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "sortNo", $$v)
                          },
                          expression: "model.sortNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.isRoutePremission"]
                      }
                    },
                    [
                      _c("a-switch", {
                        attrs: {
                          checkedChildren: _vm.language["common.yes"],
                          unCheckedChildren: _vm.language["common.no"]
                        },
                        model: {
                          value: _vm.model.route,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "route", $$v)
                          },
                          expression: "model.route"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.hidden"]
                      }
                    },
                    [
                      _c("a-switch", {
                        attrs: {
                          checkedChildren: _vm.language["common.yes"],
                          unCheckedChildren: _vm.language["common.no"]
                        },
                        model: {
                          value: _vm.model.hidden,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "hidden", $$v)
                          },
                          expression: "model.hidden"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.keepAlive"]
                      }
                    },
                    [
                      _c("a-switch", {
                        attrs: {
                          checkedChildren: _vm.language["common.yes"],
                          unCheckedChildren: _vm.language["common.no"]
                        },
                        model: {
                          value: _vm.model.keepAlive,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "keepAlive", $$v)
                          },
                          expression: "model.keepAlive"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.alwaysShow"]
                      }
                    },
                    [
                      _c("a-switch", {
                        attrs: {
                          checkedChildren: _vm.language["common.yes"],
                          unCheckedChildren: _vm.language["common.no"]
                        },
                        model: {
                          value: _vm.model.alwaysShow,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "alwaysShow", $$v)
                          },
                          expression: "model.alwaysShow"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show,
                          expression: "show"
                        }
                      ],
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: _vm.language["premission.internalOrExternal"]
                      }
                    },
                    [
                      _c("a-switch", {
                        attrs: {
                          checkedChildren: _vm.language["premission.internal"],
                          unCheckedChildren: _vm.language["premission.external"]
                        },
                        model: {
                          value: _vm.model.internalOrExternal,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "internalOrExternal", $$v)
                          },
                          expression: "model.internalOrExternal"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        label: _vm.language["system.permission.extInfo"],
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        prop: "extInfo"
                      }
                    },
                    [
                      _c("a-textarea", {
                        attrs: {
                          rows: "2",
                          placeholder:
                            _vm.language["common.pleaseInput"] +
                            _vm.language["system.permission.extInfo"],
                          readOnly: _vm.disableSubmit
                        },
                        model: {
                          value: _vm.model.extInfo,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "extInfo", $$v)
                          },
                          expression: "model.extInfo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("icons", {
                attrs: { iconChooseVisible: _vm.iconChooseVisible },
                on: {
                  choose: _vm.handleIconChoose,
                  close: _vm.handleIconCancel
                }
              })
            ],
            1
          ),
          _c(
            "a-row",
            { style: { textAlign: "right" } },
            [
              _c(
                "a-button",
                {
                  style: { marginRight: "8px" },
                  on: { click: _vm.handleCancel }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.language["common.closeButton"]) +
                      "\n      "
                  )
                ]
              ),
              _c(
                "a-button",
                {
                  attrs: { disabled: _vm.disableSubmit, type: "primary" },
                  on: { click: _vm.handleOk }
                },
                [_vm._v(_vm._s(_vm.language["common.determineButton"]))]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }